module.exports = __webpack_public_path__ + "img/rux-drawing.3887026e.png";